var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8532 2.0625H23.5078L15.5235 11.1879L24.9163 23.6056H17.5618L11.8015 16.0744L5.21045 23.6056H1.55364L10.0936 13.8449L1.08301 2.0625H8.62421L13.831 8.94636L19.8532 2.0625ZM18.5705 21.4182H20.5956L7.52385 4.13506H5.35076L18.5705 21.4182Z",
    fill: "#57585A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b7de0139afcc524ff0737922a40a1c8d.svg";
export { ForwardRef as ReactComponent };